import React from "react";
import { ImageListComponentEditor } from "cms/components/components/image-list/edit";
import { ImageListComponentDisplay } from "cms/components/components/image-list/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const ImageListComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <ImageListComponentDisplay />,
        editComponent: <ImageListComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

ImageListComponent.displayName = "ImageListComponent";
export { ImageListComponent };
